import { useState } from 'react';
import './username.css';
import lockShieldImg from '../assets/icon.png';

const MAX_LENGTH = 20;

function ChevronLeftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function PersonIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3.4" stroke="#8a6df1" strokeWidth="1.8" />
      <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" stroke="#8a6df1" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function ShieldCheckIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3l7 3v5c0 5-3.4 8.4-7 10-3.6-1.6-7-5-7-10V6l7-3Z"
        stroke="#8a6df1"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M9 12l2 2 4-4" stroke="#8a6df1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function CheckCircleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8.5 12.2l2.3 2.3 4.7-4.7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const GUIDELINES = [
  'Must be 4-20 characters long',
  'Can use letters, numbers and underscores',
  'Must be unique',
];

export default function UsernameStep({ onBack, onContinue }) {
  const [username, setUsername] = useState('');

  const isValid = /^[a-zA-Z0-9_]{4,20}$/.test(username);

  return (
    <div className="username-screen">
      <div className="username-frame">
        <div className="username-header">
          <button type="button" className="username-back-btn" onClick={onBack} aria-label="Go back">
            <ChevronLeftIcon />
          </button>

          <div className="username-glow" />
          <div className="username-icon-wrap">
            <img src={lockShieldImg} alt="" className="username-icon-img" />
          </div>
          <h1 className="username-title">Almost There!</h1>
          <p className="username-subtitle">Let&apos;s get to know you better</p>
        </div>

        <form
          className="username-card"
          onSubmit={(e) => {
            e.preventDefault();
            if (isValid) onContinue?.({ username });
          }}
        >
          <h2 className="username-card-title">Create a username</h2>
          <p className="username-card-subtitle">Choose a unique username for your account</p>

          <div className="username-field">
            <label className="username-label" htmlFor="username">
              Username
            </label>
            <div className="username-input-wrap">
              <PersonIcon />
              <input
                id="username"
                type="text"
                placeholder="Enter your username"
                maxLength={MAX_LENGTH}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <span className="username-count">
                {username.length}/{MAX_LENGTH}
              </span>
            </div>
          </div>

          <div className="username-guidelines">
            <div className="username-guidelines-title">
              <ShieldCheckIcon />
              Username guidelines
            </div>
            <div className="username-guidelines-list">
              {GUIDELINES.map((text) => (
                <div className="username-guideline-item" key={text}>
                  <CheckCircleIcon />
                  {text}
                </div>
              ))}
            </div>
          </div>

          <button type="submit" className="username-submit" disabled={!isValid}>
            Next <ArrowRightIcon />
          </button>
        </form>
      </div>
    </div>
  );
}
